// extracted by mini-css-extract-plugin
export var teleformContainer = "teleformulaire-module--teleform-container--e2c77";
export var teleformFooter = "teleformulaire-module--teleform-footer--a6683";
export var teleformLibre = "teleformulaire-module--teleform-libre--0f236";
export var teleformLinks = "teleformulaire-module--teleform-links--f2810";
export var teleformLinksItem = "teleformulaire-module--teleform-links-item--9e20b";
export var teleformLinksItemTitle = "teleformulaire-module--teleform-links-item-title--5a26f";
export var teleformLinksList = "teleformulaire-module--teleform-links-list--7c2a7";
export var teleformLinksTitle = "teleformulaire-module--teleform-links-title--6c6a7";
export var teleformTaxo = "teleformulaire-module--teleform-taxo--77782";
export var teleformTaxoItem = "teleformulaire-module--teleform-taxo-item--303be";
export var teleformTitle = "teleformulaire-module--teleform-title--51526";
export var teleformulaire = "teleformulaire-module--teleformulaire--1aab4";